import React, { Component } from 'react'
import SystemLabelMasterCollection from 'collections/system_label_master_collection'

class SelectSyaryougaisunHeight extends Component {

  handleChangeStart = (e) => {
    this.props.actions.changeSelectSyaryougaisunHeightStart({
      selectSyaryougaisunHeightStart: e.target.value,
    })
  }

  handleChangeFinish = (e) => {
    this.props.actions.changeSelectSyaryougaisunHeightFinish({
      selectSyaryougaisunHeightFinish: e.target.value,
    })
  }

  render() {
    const { payload } = this.props.systemLabelMastersApi
    if (!payload) {
      return null
    }
    const systemLabelMasterCollection = new SystemLabelMasterCollection(payload)
    return (
      <div className='searchArea__item'>
        <h3 className='searchArea__title'>{TRUCKERS.LANG.ITEM.SYARYOUGAISUN_HEIGHT}</h3>
        <div className='searchArea__item__half searchArea__item__inner'>
          <p className='selectWrap'>
            <select
              className='select'
              value={this.props.selectSyaryougaisunHeightStart}
              onChange={this.handleChangeStart}
            >
              <option value="">{TRUCKERS.LANG.ITEM.LIST_SEARCH.LOWER}</option>
              {
                systemLabelMasterCollection.getValueList('item', 'select_syaryougaisun_height').map(i => {
                  return <option key={i.get('label_key')} value={i.get('label_key')}>{i.getValueI18n()}</option>
                })
              }
            </select>
          </p>
          <p>〜</p>
          <p className='selectWrap'>
            <select
              className='select'
              value={this.props.selectSyaryougaisunHeightFinish}
              onChange={this.handleChangeFinish}
            >
              <option value="">{TRUCKERS.LANG.ITEM.LIST_SEARCH.UPPER}</option>
              {
                systemLabelMasterCollection.getValueList('item', 'select_syaryougaisun_height').map(i => {
                  return <option key={i.get('label_key')} value={i.get('label_key')}>{i.getValueI18n()}</option>
                })
              }
            </select>
          </p>
        </div>
      </div>
    )
  }
}

export default SelectSyaryougaisunHeight
